import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IAuthorizedServiceProcedurs } from '../models/models'

export class GetAuthorizedServicesProcedurApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'authorizedServiceProcedurs/listAll',
      requesterInfo,
    })
  }

  public async getAuthorizedServicesProcedur(): Promise<IAuthorizedServiceProcedurs[]> {
    return await this.getAsync<IAuthorizedServiceProcedurs[]>()
  }
}
